import { postApi } from "../api/services";
import { setfrontview, setleftview, setrightview, settopview } from "../Reducers/reducer";

export const ApiKey = 'AIzaSyBFM12149m7AWt7qpNVGAZHKw8AlKc7pEI'

export const compressBase64Image = async (
    base64String,
    maxSizeMB = 1,
    maxWidthOrHeight = 800
  ) => {
  // Convert Base64 to Blob
  const blob = base64ToBlob(base64String);
  // Compression options
  const options = {
    maxSizeMB: maxSizeMB, // Target size in MB
    maxWidthOrHeight: maxWidthOrHeight, // Resize dimension
    useWebWorker: true,
  };
  try {
    // Compress the image
    const compressedBlob = await imageCompression(blob, options);
    // Convert back to Base64
    const compressedBase64 = await blobToBase64(compressedBlob);
    return compressedBase64.split(",")[1];
  } catch (error) {
    return base64String; // Return original if compression fails
  }
}

// Convert Blob to Base64
export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
  });
}

export const base64ToBlob = (base64String, mimeType = "image/jpg") => {
  const byteCharacters = atob(base64String); // Decode Base64
  const byteArrays = [];
  for (let i = 0; i < byteCharacters.length; i += 512) {
    const slice = byteCharacters.slice(i, i + 512);
    const byteNumbers = new Array(slice.length);
    for (let j = 0; j < slice.length; j++) {
      byteNumbers[j] = slice.charCodeAt(j);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }
  return new Blob(byteArrays, { type: mimeType });
}

export const clearImagesInRedux = (dispatch) => {             /// clear the captured images from redux
  dispatch(setfrontview(""));
  dispatch(settopview(""));
  dispatch(setleftview(""));
  dispatch(setrightview(""));
}

export const downloadPDF = (base64Data, name, lang) => {
  // Convert base64 to binary string
  const byteCharacters = atob(base64Data);
  // Convert binary string to bytes
  const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) =>
    byteCharacters.charCodeAt(i)
  );
  const byteArray = new Uint8Array(byteNumbers);
  // Create a Blob from the byte array
  const blob = new Blob([byteArray], { type: "application/pdf" });
  // Create a temporary download link
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  if(lang && lang !== ''){
    link.download = `${name}-${lang}.pdf`;
  } else {
    link.download = `${name}.pdf`;
  }
  document.body.appendChild(link);
  link.click();
  // Clean up
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

export const serviceDown = (navigate, to) => {
  swal({
    title: "Something went wrong",
    text: "Please try again after sometime",
    icon: 'warning',
    // closeOnClickOutside: false
  }).then((val) => {
    if(val && navigate && to){
      navigate(to)
    }
  })
}

export const gTagTracking = async (eventName, params) => {
  if(window?.gtag){
    console.log("gTagTracking params", params)
    window.gtag('event', eventName, params)
  }
}

export const gTagPageTracking = async (page) => {
  const ADS_ID = "AW-17407079819"
  const MAP_LABELS = {
    "preview": "we3zCNbgkNIbEIvrq-xA",
    "otppage": "NUFMCNPgkNIbEIvrq-xA",
    "prescriptions": "sxgLCMz9jNIbEIvrq-xA",
    "report": "bLoiCM_9jNIbEIvrq-xA",
  };

  const label = MAP_LABELS[page];

  if(window?.gtag && label){
    console.log("gTagPageTracking send_to", `${ADS_ID}/${label}`)
    window.gtag("event", "conversion", {
      page_path: `/${page}`,
      send_to: `${ADS_ID}/${label}`,
    })
  }
}

export const trackEvent = async (event, status, error, mob_no, userId) => {
  let params = {
    action: event,
    status: status,
    error: error,
    mobile_number: mob_no,
    user_id: userId
  }
  console.log("update_user_journey params", params);
  try{
    const res = await postApi('update_user_journey', params)
    console.log("update_user_journey res", res);
  } catch (err){
    console.log("err", err);
  }
}

export const fetchLocation = async () => {     //async function to get current location
  try {
    const position = await getCurrentLocation();
    const coordinates = [position.coords.latitude, position.coords.longitude];
    return coordinates;
  } catch (err) {
    console.error("Error fetching location:", err);
  }
}

const getCurrentLocation = () => {             //promise to get current geolocation
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve(position);
        },
        (error) => {
          reject(error);
        },
        { timeout: 10000 } // timeout setting
      );
    } else {
      reject(new Error('Geolocation not supported'));
    }
  });
};

export const getQueryParams = (url) => {
  if (!url || typeof url !== 'string') {
    return { params: {}, cleanUrl: '' };
  }

  try {
    const hashIndex = url.indexOf('#');
    let queryString = '';
    let cleanUrl = url;

    if (hashIndex !== -1) {
      // Extract the hash part (e.g., "/selectgender?gender=%22female%22")
      const hashPart = url.substring(hashIndex + 1);

      if (hashPart.includes('?')) {
        const [path, query] = hashPart.split('?');
        queryString = query;
        cleanUrl = url.split('?')[0]; // remove query string from hash-based URL
      }
    } else {
      // For normal URLs (non-hash)
      const urlObj = new URL(url);
      queryString = urlObj.searchParams.toString();
      urlObj.search = ''; // remove query params
      cleanUrl = urlObj.toString();
    }

    // Parse the query string
    const params = {};

    if (queryString) {
      const searchParams = new URLSearchParams(queryString);

      for (const [key, value] of searchParams.entries()) {
        // Explicitly decode URI component and remove surrounding quotes
        let decodedValue = decodeURIComponent(value);
        // Remove surrounding quotes (both single and double) and trim whitespace
        decodedValue = decodedValue.replace(/^["']|["']$/g, '').trim();
        params[key] = decodedValue;
      }
    }

    return { params, cleanUrl };
  } catch (error) {
    console.error('Error parsing URL parameters:', error);
    return { params: {}, cleanUrl: '' };
  }
};